import React from "react";
import {
  fetchMedicalRecords,
  updateMedicalRecord,
} from "./../../../actions/medicalRecords";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import "react-select/dist/react-select.css";
import { NavLink } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import classnames from "classnames";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Responsive from "react-responsive";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";


const $ = window.$;
const { SearchBar } = Search;
const petAvailabilityStatus = {
    available:"available",
    sold:"sold",
    medicalRecordAvailable:"Available"
};
const descriptionAvailability = {
  filled : "Filled",
  blank : "Blank"
};
var _self;
const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal'

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
    _self = this;
  }
  state = {
    cdAvailable: [],
    selectedTab: "All", 
    //medical_record: false,
    editMedicalRecord : null,
    personality_description : "",
    pet_name : "", 
    avatar_file_name: "",
    avatar_path: "",
    enableImageSlider: false,
    allPetImages :[],
    arrivalDateValidationMessage: 'Arrival date should be 8 weeks greater than the selected "Date of Birth"',
  };

  tableHeaderColumnData = [
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.buttonFormatter.bind(this),
      headerStyle: (column, colIndex) => {
        return { width: '60px' };
      },
    },

    {
      dataField: "pet_id",
      text: "Pet Id",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{cell}</strong>
            </span>
          </span>
        );
      }
    },
    {
      dataField: "breed_type",
      text: "Breed",
      sort: true
    },
    {
      dataField: "sex",
      text: "Gender",
      sort: true,
      formatter: cell => cell
    },

    {
      dataField: "color_markings",
      text: "Color",
      sort: true
    },
    {
      dataField: "date_of_birth",
      text: "Date Of Birth",
      formatter: cell => moment(new Date(cell.replace(/-/g, "/"))).format("MM-DD-YYYY"),
      sort: true
    },
     {
      dataField: "arrival_date",
      text: "Arrival Date",
      formatter: cell => moment(cell).format("MM-DD-YYYY"),
      sort: true
    },  
    {
      dataField: "descriptionStatus",
      text: "Personality Description ",
      sort: true,
      formatter: (cell, row) => {
        return (      
          <div>
            <span
              className={
                "m-badge mx-auto my-0 px-2 " +
                (cell === descriptionAvailability.filled
                  ? "m-badge--success"
                  : cell === descriptionAvailability.blank
                    ? "m-badge--warning mb-2"
                    : " m-badge--wide")
              }
            >
              <strong>{cell}</strong>         
            </span> 
          <br/>         
          </div> 
              
        );
            }
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
          { row.woo_pet_availability === petAvailabilityStatus.available ?
          <div>
          <span
            className={
              "m-badge mx-auto my-0 px-2 " +
              (cell === "Available"
                ? "m-badge--success"
                : cell === "Sold"
                  ? "m-badge--danger mb-2"
                  : " m-badge--wide")
            }
          >
            <strong>{cell}</strong>         
          </span> 
          <br/>
            <span>
              {row.Contract != null ? <NavLink style={{ 
                  whiteSpace: "nowrap",
                  width: "70px", 
                  overflow: "hidden",
                  textOverflow: "ellipsis",
              }}
                    target="_blank"
                    to={`/contracts/${row.Contract.id}`}
                    className="m-badge mx-auto my-0 px-2 m-badge--success"
                    title="View Contract"
                  >
                    {row.Contract.Customer ? row.Contract.Customer.firstname: ''}
                  </NavLink> : ""}  
                </span>   
            </div>
            :<div>
            {row.woo_pet_availability === petAvailabilityStatus.sold && row.Contract == null && (               
            <div>
              <span  className="m-badge mx-auto my-0 px-2 m-badge--danger mb-2">
                <strong>Sold</strong> 
              </span>
              <br/>
              <span className="m-badge mx-auto my-0 px-1 m-badge--warning">
                <strong>No Contract</strong> 
              </span>
            </div>
            )}                  
            </div>}  
          </div>
        );
      }
    }
  ];

  buttonFormatter(cell, row, rowIndex) {
      return (
      <div>   
         <button
          onClick={(e) => this.openEditDescriptionModal(e, row)}
          className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View" 
        >
          <i className="la la-edit"></i>
        </button>       
      </div>
    );
  } 

  openEditDescriptionModal(e,medicalRecord){   
    let images_Array = [];
    if(medicalRecord){
      if( medicalRecord.image02_file_name && medicalRecord.image02_path ){
        images_Array.push({ avatar_path : medicalRecord.avatar_path, avatar_file_name : medicalRecord.avatar_file_name },{ avatar_path : medicalRecord.image02_path, avatar_file_name : medicalRecord.image02_file_name });
        this.setState({ enableImageSlider : true });
      }
      if( medicalRecord.image03_file_name && medicalRecord.image03_path ){
        images_Array.push({ avatar_path : medicalRecord.image03_path, avatar_file_name : medicalRecord.image03_file_name });
      }
      if( medicalRecord.image04_file_name && medicalRecord.image04_path ){
        images_Array.push({ avatar_path : medicalRecord.image04_path, avatar_file_name : medicalRecord.image04_file_name });
      }
      if( medicalRecord.image05_file_name && medicalRecord.image05_path ){
        images_Array.push({ avatar_path : medicalRecord.image05_path, avatar_file_name : medicalRecord.image05_file_name });
      }  
      this.setState({ 
        personality_description : medicalRecord.personality_description ? medicalRecord.personality_description : "",       
        pet_name : medicalRecord.pet_name ?  medicalRecord.pet_name :"",
        editMedicalRecord : medicalRecord,
        avatar_path : medicalRecord.avatar_path,
        avatar_file_name : medicalRecord.avatar_file_name,
        allPetImages : images_Array    
        });
        $("#edit_description_modal").modal("show");  
    }
    else{
      NotificationManager.error("Medical Record Not Found");
    }

    }
 
    editDescription(){    
      let medicalRecordObj = this.state.editMedicalRecord;
      const medicalRecordId = medicalRecordObj.id;       
      if(this.state.personality_description.trim().length <= 2000 ){              
        if(this.state.pet_name || this.state.personality_description ){      
            medicalRecordObj.pet_name = this.state.pet_name;          
            medicalRecordObj.availablePetId = true;    
            medicalRecordObj.personality_description = this.state.personality_description.trim();  
            this.props.updateMedicalRecord(medicalRecordId, medicalRecordObj);
        }else{
            NotificationManager.warning("Please check input details again.");
        }
      }
      else{
        NotificationManager.warning("Description length exceeds maximum");   
      } 
 }

  changeVal = event => {
    this.setState({ [event.target.name]: event.target.value });
  };


  componentDidMount() {
    this.props.fetchMedicalRecords(); 
  }

  componentWillReceiveProps =  nextProps => {

    if (nextProps.data.medicalRecordsReducer.mRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords.length > 0 &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords !==
      this.props.data.medicalRecordsReducer.mRecords.medicalRecords 
    ) {
      let records = nextProps.data.medicalRecordsReducer.mRecords.medicalRecords;       
        records = records.map((record , index) => {          
          if(record.Contract && record.Contract.Customer){
            record.customer = record.Contract.Customer.firstname+" "+ record.Contract.Customer.lastname;
          }
          if(record.personality_description){
            record.descriptionStatus = "Filled";
          }
          else{
            record.descriptionStatus = "Blank";
          }      
          return record;                 
        })
      
      records.sort((a, b) => (a.id > b.id ? -1 : 1));  
      let cdAvailable = records.filter(     
        m => m.status ===  petAvailabilityStatus.medicalRecordAvailable &&
        m.woo_pet_availability === petAvailabilityStatus.available
      );        
        this.setState({ cdAvailable: cdAvailable,});
    }  

    if (this.props.data.medicalRecordsReducer.updatedMRecord !== nextProps.data.medicalRecordsReducer.updatedMRecord) {
      this.props.fetchMedicalRecords(); 
      this.setState({ editMedicalRecord : null, personality_description: "", pet_name : "", allPetImages : [],enableImageSlider: false }); 
      $("#edit_description_modal").modal("hide");   
      NotificationManager.success("Medical record updated successfully.");
      
    }
  };

  closeModal = () => {
    this.setState({enableImageSlider: false, allPetImages : [],  editMedicalRecord : null, personality_description: "", pet_name : ""})
    $("#edit_description_modal").modal("hide");  
  }

  items = [{ title: "Puppy Records", }];

  render() {
    const { classes, theme } = this.props;
    const {  
      cdAvailable,    
      personality_description,
      pet_name,
      avatar_file_name,
      avatar_path
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set" >
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Puppy Records
                        <small>List of all the available medical records</small>
                      </h3>
                    </div>
                  </div>            
                </div>
                <div className="m-portlet__body medical-record-content">               
                  <div className="tab-content">
                    <ToolkitProvider
                      keyField="id"
                      data={cdAvailable}
                      columns={this.tableHeaderColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>
                          <div className="mb-2">                       
                          </div>                   
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                            />                     
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="edit_description_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="SectionSelectModalLabel"
                aria-hidden="true"             
              >
                <div className="modal-dialog modal-md" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit
                      </h5>
                      <button
                        type="button"
                        className="close"
                        onClick={() => this.closeModal()}
                        aria-label="Close"
                        data-dismiss="modal"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                    <form className="m-form m-form--label-align-left- m-form--state-">                   
                   { this.state.enableImageSlider ?
                    <div className="row m--align-center justify-content-center">
                    <div className="col-8">
                    <Carousel  showArrows={true} >
                      { this.state.allPetImages .map(item =>
                        ( <div >
                          <img src={
                          process.env.REACT_APP_S3_PATH +
                          "/" + item.avatar_path +
                          "/" + item.avatar_file_name
                          }
                         alt=""
                         />
                        </div> )
                       )             
                     }               
                    </Carousel>
                    </div>
                    </div>:   
                     <div className="row m--align-center">
                          <div className={classnames({
                            "m-widget4__img m-widget4__img--pic my-0": true,
                             "user-avatar mx-auto": !this.state.imgSrc01,
                             "m-width-100-perc": this.state.imgSrc01
                             })}>
                            <img src={
                              process.env.REACT_APP_S3_PATH +
                                "/" + avatar_path +
                                "/" + avatar_file_name
                              }
                            alt=""
                            />
                          </div>
                    </div>         
                    }
             
                    <div className="form-group m-form__group row mb-0">
                      <label className="col-4 pt-3">
                        Pet Name:
                      </label>
                      <div className="col-8 input-group m-input-group pl-0">                  
                         <input
                          type="text"
                          name="pet_name"
                          onChange={this.changeVal}
                          className="form-control m-input"
                          placeholder=""
                          value={pet_name}
                        />                            
                        </div>                                            
                      </div>
                      <div className="form-group m-form__group row mb-0">
                      <label className="col-4 pt-3">
                        Personality Description:
                      </label>
                      <div className="col-8 input-group m-input-group pl-0"> 
                       <textarea
                        className="form-control m-input"
                        name="personality_description"
                        onChange={this.changeVal}
                        value={personality_description}
                        id="exampleTextarea"
                        rows="5"
                      ></textarea>                         
                     </div>                                              
                      </div>
                      <div className="m-form row pt-0">   
                      <div className="col-12">                                
                           <div className="text-right">
                                  <span className='complaint-word-count'>{ personality_description &&  personality_description.trim().length > 0 ? personality_description.trim().length : 0 }/2000</span>
                            </div>
                            <div className="text-right">
                            <span
                            className={personality_description && personality_description.trim().length > 2000 ?                                         
                                        "m-form__help_danger"
                                          : "display-none"}
                            >
                            Description length exceeds maximum
                            </span>  
                           </div>
                      </div>  
                       </div> 	                   
	                   </form>               
                    </div>
                    <div className="modal-footer">
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            onClick={() => this.closeModal()}
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={(e) => this.editDescription(e)}
                            className="btn btn-primary m-btn--pill"
                          >
                            Update
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>         
            </div>
          </div>
        </div>         
      </div>
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = state => ({
  data: state,

});

const mapDispatchToProps = dispatch => ({
  fetchMedicalRecords: () => {
    dispatch(fetchMedicalRecords());
  },
  updateMedicalRecord: (id, data) => {
    dispatch(updateMedicalRecord(id, data));
  },

  
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);

